import type { GroupType } from '../../types.ts'

/**
 * Per-Gruppentyp Farb-Klassen fuer den MatrixTable-Mega-Header.
 * Das ist eine bewusste Ausnahme von der Badge-/StatusBadge-Regel, weil es
 * sich um ein spaltenweit durchgezogenes visuelles Gruppierungs-Element
 * handelt, nicht um einen Status-Pill. Zentral gehalten damit alle Matrizen
 * (User/Abteilung/Zugriff) denselben Farb-Code nutzen.
 */
export const GROUP_TYPE_HEADER_CLASS: Record<GroupType, string> = {
  AB: 'bg-blue-100 text-blue-900',
  SW: 'bg-emerald-100 text-emerald-900',
  LI: 'bg-amber-100 text-amber-900',
  FU: 'bg-purple-100 text-purple-900',
  LW: 'bg-gray-100 text-gray-900',
  PR: 'bg-orange-100 text-orange-900',
  SA: 'bg-slate-100 text-slate-900',
}
